<template>
  <div class="container mt-5" style="margin-top:7%!important;padding: 20px;">
    <h1 class="mb-4">Lista de Catálogos</h1>

    <div class="d-flex justify-content-center" v-if="loading">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div v-else>
      <div v-if="documentos.length === 0" class="alert alert-info" role="alert">
        No hay catálogos disponibles.
      </div>

      <div v-if="documentos.length > 0">
        <div class="row mb-4" style="background-color: #f8f9fa; padding: 10px; border-radius: 10px;">
          <div class="col-md-6 offset-md-3">
            <input v-model="busqueda" @input="filtrarDocumentos" class="form-control"
              placeholder="Buscar por clave o empresa">
          </div>
        </div>

        <div class="row">
          <div class="col-md-4 animated fadeIn"
            v-for="(documento, index) in documentosFiltrados.slice(0, cantidadMostrar)" :key="documento.id"
            :style="{ 'animation-delay': `${index * 0.2}s` }" ref="cards">
            <div class="card mb-4 shadow-lg rounded custom-hover-card" style="height: 51vh;">
              <img :src="documento.img ? '/img/' + documento.img : imagenDefault(documento.empresa).src"
                @error="imagenNoEncontrada(documento)" class="card-img-top  imagen-catalogo" alt="Imagen del catálogo"
                style="height: 35vh; "
                :style="documento.img ? {} : imagenDefault(documento.empresa).style">
              <div class="card-body" style="position: relative;">
                <h5 class="card-title">
                  <p style="color:#ffc107;">{{ documento.clave }}</p>
                </h5>
                <h6 class="card-text">
                  <p style="color:#06283c;">{{ documento.empresa }}</p>
                </h6>




                <a v-if="documento.namedocpdf" @click="testDownload(documento.namedocpdf)" class="btn btn-primary mt-3"
                  target="_blank"
                  style="position: absolute; bottom: 10px; left: 50%; transform: translateX(-50%);color:white;background-color: #06283c; ">Descargar</a>
                <a v-else :href="`${documento.link}`" class="btn btn-primary mt-3" target="_blank"
                  style="position: absolute; bottom: 10px; left: 50%; transform: translateX(-50%);color:white;background-color: #06283c; ">Descargar</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      documentos: [],
      cantidadMostrar: 6,
      busqueda: '',
      loading: false,
    };
  },
  computed: {
    documentosFiltrados() {
      const busqueda = this.busqueda?.toLowerCase() || '';
      return this.documentos.filter(documento =>
        (documento.clave?.toLowerCase().includes(busqueda) || '') ||
        (documento.empresa?.toLowerCase().includes(busqueda) || '')
      );
    },
  },
  mounted() {
    this.cargarDocumentos();
    this.scrollListener();
  },
  methods: {
    async testDownload(archivo) {
      try {
        // URL de la ruta de prueba
        let downloadUrl = `/test-download/${archivo}`;
        //console.log(`Attempting to download from URL: ${downloadUrl}`);
        const response = await axios.get(downloadUrl, {
          responseType: 'blob' // Importante para recibir el archivo como un Blob
        });

        //console.log(`Response received:`, response);

        // Crear un objeto URL para el blob
        const url = window.URL.createObjectURL(new Blob([response.data]));
        //console.log(`Blob URL created: ${url}`);

        // Crear un enlace temporal y hacer clic en él para descargar el archivo
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', archivo);
        document.body.appendChild(link);
        link.click();

        // Limpiar el enlace temporal y revocar el objeto URL
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        // Mostrar el contenido de la respuesta
        //console.log('Response:', response.data);
        
      } catch (error) {
        console.error('Error:', error);
        
      }
    },
    imagenNoEncontrada(documento) {
      console.error('La imagen no se pudo cargar. Ruta:', documento.img);
    },
    cargarDocumentos() {
      this.loading = true,
        axios.get('/api/documentos/index')
          .then(response => {
            this.documentos = response.data;
            //console.log(response.data);
            this.loading = false
          })
          .catch(error => {
            console.error('Error al cargar documentos: ', error);
            console.error(error.response.data);
            this.loading = false
          });
    },
    imagenDefault(empresa, documento) {
      const estiloDefault = { height: '51vh' };
      if (empresa === 'VAZLO' || empresa === 'SPR' || empresa === 'GSP'  || empresa === 'MNCH') {
        return { src: `/img/${empresa.toLowerCase()}.png`, style: { height: '15vh', marginTop: '100px' } };
      } else {
        return { src: documento.img, style: estiloDefault };
      }
    },
    cargarMas() {
      this.cantidadMostrar += 3;

      this.scrollToBottom();

    },
    scrollListener() {
      window.addEventListener('scroll', this.handleScroll);
    },
    handleScroll() {
      const bottomOfWindow = Math.max(window.scrollY + window.innerHeight) >= document.documentElement.scrollHeight;

      if (bottomOfWindow) {
        // Cargar más documentos cuando se llega al final de la página
        this.cargarMas();
      }
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll);
    },

    /*
        scrollToBottom() {
          // Utiliza la función animate para hacer scroll hacia abajo
          const targetPosition = document.body.scrollHeight;
          const startPosition = window.scrollY;
          const distance = targetPosition - startPosition;
          const duration = 1000; // 1000 ms o 1 segundo
    
          let start = null;
    
          const scrollStep = (timestamp) => {
            if (!start) start = timestamp;
            const progress = timestamp - start;
    
            window.scrollTo(0, startPosition + (distance * progress) / duration);
    
            if (progress < duration) {
              requestAnimationFrame(scrollStep);
            }
          };
    
          requestAnimationFrame(scrollStep);
        }, */

    filtrarDocumentos() {

    },
  },
};
</script>

<style scoped>
.custom-hover-card {
  transition: box-shadow 0.3s ease;
}

.custom-hover-card:hover {
  box-shadow: 0 4px 8px rgba(255, 193, 7, 0.5);
}

.imagen-catalogo {
  height: 35vh;
  width: 100%;
  object-fit: cover;
  /* Asegura que la imagen se ajuste al contenedor */
  margin-left: auto;
  margin-right: auto;
}

.animated {
  animation-fill-mode: both;
}

.fadeIn {
  animation: fadeIn 0.5s;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translate3d(0, -50px, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
</style>
